module.exports = __webpack_public_path__ + "static/img/SCN_g.4d4e3c61.png";